module.exports = __webpack_public_path__ + "img/0a34e36.jpg";